const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPreReminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 9.199219 3.799805 C 8.701172 3.799805 8.200195 3.899414 7.798828 3.999023 C 7.798828 3.999023 7.798828 3.999023 7.798828 3.899414 C 7.798828 3 8.100586 2.299805 9.099609 2.299805 C 10.098633 2.299805 10.400391 3.099609 10.400391 3.899414 C 9.999023 3.899414 9.600586 3.799805 9.199219 3.799805 Z M 11.000977 14.000977 C 11.000977 14.701172 10.5 15.899414 9.199219 15.899414 C 8.000977 15.899414 7.400391 14.598633 7.400391 14.000977 L 7.798828 14.000977 C 7.901367 14.000977 11.000977 14.000977 11.000977 14.000977 Z M 11.000977 14.000977 ",
    transform: "matrix(1.333333,0,0,1.333333,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 18 10.667969 C 17.867188 10.667969 17.734375 10.535156 17.734375 10.398438 L 17.734375 8 C 17.734375 7.867188 17.867188 7.734375 18 7.734375 C 18.132812 7.734375 18.265625 7.867188 18.265625 8 L 18.265625 10.398438 C 18.265625 10.535156 18.132812 10.667969 18 10.667969 Z M 18 10.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 16.535156 11.332031 C 16.398438 11.199219 16.535156 11.066406 16.667969 10.933594 L 17.867188 10.265625 C 18 10.132812 18.132812 10.265625 18.265625 10.398438 C 18.398438 10.535156 18.265625 10.667969 18.132812 10.800781 L 16.933594 11.464844 C 16.800781 11.464844 16.667969 11.464844 16.535156 11.332031 Z M 16.535156 11.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 13.5 5.000977 C 14.900391 5.000977 15.999023 6.099609 15.999023 7.5 C 15.999023 8.900391 14.900391 9.999023 13.5 9.999023 C 12.099609 9.999023 11.000977 8.900391 11.000977 7.5 C 11.000977 6.099609 12 5.000977 13.5 5.000977 Z M 13.5 5.000977 ",
    transform: "matrix(1.333333,0,0,1.333333,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 13.901367 12 L 13.5 12 C 13.5 11.800781 13.5 12 13.5 11.299805 C 13.5 11.299805 13.5 10.300781 13.5 10.201172 C 13.5 10.201172 13.5 10.201172 13.5 10.098633 C 12.099609 10.098633 10.901367 8.900391 10.901367 7.5 C 10.901367 6.600586 11.399414 5.701172 12.099609 5.299805 C 12 5.100586 12 5.000977 12 5.000977 C 11.200195 4.300781 10.201172 3.899414 9.099609 3.899414 C 7.798828 3.899414 6.600586 4.5 5.800781 5.399414 C 5.299805 6 4.901367 6.799805 4.699219 7.599609 C 4.699219 7.901367 4.699219 11.399414 4.699219 12 L 4.300781 12 C 3.899414 12 3.500977 12.401367 3.500977 12.799805 L 3.500977 12.999023 C 3.500977 13.400391 3.899414 13.798828 4.300781 13.798828 L 13.901367 13.798828 C 14.299805 13.798828 14.701172 13.400391 14.701172 12.999023 L 14.701172 12.799805 C 14.701172 12.298828 14.399414 12 13.901367 12 Z M 13.901367 12 ",
    transform: "matrix(1.333333,0,0,1.333333,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPreReminder);
export default __webpack_public_path__ + "static/media/ic_pre_reminder.e1b4d9e5b0934dd594cffdd619adbfd7.svg";
export { ForwardRef as ReactComponent };